module.exports = __webpack_public_path__ + "img/fee.d13d9118.png";